import React from 'react';
import ViewCounter from './ViewCounter';
import styles from '../GuidanceCard.scss';

interface ViewCountersProps {
  totalNum: number;
  weeklyNum: number;
}

const ViewCounterRow = ({ totalNum, weeklyNum }: ViewCountersProps) => {
  return (
    <div className={styles.counterRow}>
      <ViewCounter value={weeklyNum} description={'this week'} />
      <ViewCounter value={totalNum} description={'total'} />
    </div>
  );
};

export default ViewCounterRow;
